import React from 'react';

import IconType from '../../../types/Icon';

const IncomingCall: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4 3C3.562 3 3 3.328 3 4C3 8.539 4.8408 12.8732 7.9668 16.0332C11.1268 19.1592 15.461 21 20 21C20.672 21 21 20.438 21 20V16.4902C21 15.9452 20.5684 15.5013 20.0234 15.4883C19.3934 15.4733 18.6006 15.4357 18.0996 15.3477C17.5576 15.2517 16.9043 15.0668 16.4453 14.9238C16.0853 14.8118 15.6947 14.9098 15.4277 15.1758L13.2109 17.3809C11.6789 16.5739 10.4511 15.6329 9.41211 14.5879C8.36711 13.5489 7.42614 12.3211 6.61914 10.7891L8.82422 8.57227C9.09022 8.30527 9.18817 7.91273 9.07617 7.55273C8.93417 7.09473 8.74734 6.44239 8.65234 5.90039C8.56334 5.39939 8.52772 4.60656 8.51172 3.97656C8.49872 3.43156 8.05477 3 7.50977 3H4ZM16 3L12 7L16 11V8H21V6H16V3Z"
				fill={color}
			/>
		</svg>
	);
};

export default IncomingCall;
